module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"email":"Indtast en ny e-mail adresse","placeholder":"Indtast ny e-mail","message":"Du er logget ind som <b>{fullname} ({email})</b>"},"en":{"email":"Enter a new e-mail address here","placeholder":"Enter new e-mail","message":"You are currently logged in as <b>{fullname} ({email})</b>"}}')
  delete Component.options._Ctor
}
